import React, { useEffect, useState } from "react";
import { LoadPanel } from "devextreme-react";
import "./TypeOfQueryTab.scss";
import { confirm } from "devextreme/ui/dialog";
import { ToastDisplayer } from "../../../components/toastDisplay/ToastDisplayer";
import {
  createTicketType,
  deleteTicketType,
  getTicketTypes,
  updateTicketType,
} from "../../../api/typeOfQueryTicket";
export default function TypeOfQueryTab() {
  const [loading, setLoading] = useState(false);
  const [typeList, setTypeList] = useState([]);
  const [typeInput, setTypeInput] = useState("");

  // Edit mode state
  const [editingId, setEditingId] = useState(null);
  const [editingValue, setEditingValue] = useState("");

  // ── FETCH all Type ──────────────────────────────────────────────────
  const fetchTicketTypes = async () => {
    try {
      setLoading(true);

      const res = await getTicketTypes();

      if (res.success) {
        setTypeList(res.data || []);
      }
    } catch (error) {
      ToastDisplayer(
        "error",
        error?.response?.data?.message || "Failed to fetch ticket types.",
      );
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchTicketTypes();
  }, []);

  // ── ADD Type ──────────────────────────────────────────────────────────
  const handleAddType = async () => {
    if (!typeInput.trim()) {
      ToastDisplayer("error", "Please enter a Query Type.");
      return;
    }

    try {
      setLoading(true);

      const res = await createTicketType({
        tickettypename: typeInput,
      });

      if (res.success) {
        ToastDisplayer("success", "Query Type added successfully!");
        setTypeInput("");
        fetchTicketTypes();
      } else {
        ToastDisplayer("error", res.message || "Failed to add Query Type.");
      }
    } catch (error) {
      ToastDisplayer(
        "error",
        error?.response?.data?.error ||
        error?.response?.data?.message ||
        "Failed to add Query Type.",
      );
    } finally {
      setLoading(false);
    }
  };

  // ── START editing a row ─────────────────────────────────────────────────
  const handleEditClick = (item) => {
    setEditingId(item.transid);
    setEditingValue(item.tickettypename);
  };

  // ── SAVE edited Type ──────────────────────────────────────────────────
  const handleEditSave = async (id) => {
    if (!editingValue.trim()) {
      ToastDisplayer("error", "Query Type cannot be empty.");
      return;
    }

    try {
      setLoading(true);

      const res = await updateTicketType(id, {
        tickettypename: editingValue,
      });

      if (res.success) {
        ToastDisplayer("success", "Query Type updated successfully!");
        setEditingId(null);
        setEditingValue("");
        fetchTicketTypes();
      }
    } catch (error) {
      ToastDisplayer(
        "error",
        error?.response?.data?.message || "Failed to update Query Type.",
      );
    } finally {
      setLoading(false);
    }
  };
  // ── CANCEL editing ──────────────────────────────────────────────────────
  const handleEditCancel = () => {
    setEditingId(null);
    setEditingValue("");
  };

  // ── DELETE Type ───────────────────────────────────────────────────────
  const handleDelete = async (id) => {
    confirm("Are you sure you want to delete this record?").then(
      async (result) => {
        if (!result) return;

        try {
          setLoading(true);

          const res = await deleteTicketType(id);

          if (res.success) {
            ToastDisplayer("success", "Type of Query deleted successfully!");
            fetchTicketTypes();
          }
        } catch (error) {
          ToastDisplayer(
            "error",
            error?.response?.data?.message || "Failed to delete Query type.",
          );
        } finally {
          setLoading(false);
        }
      },
    );
  };

  return (
    <>
      {loading && <LoadPanel visible={true} />}

      <div className="queryTabSec">
        {/* ── Categories-style collapsible section ── */}
        <div className="queryTabCard">
          <div className="queryCardHead">
            <span className="queryCardTitle">Manage Type Of Query</span>
          </div>

          {/* Input row — same layout as Category Name input */}
          <div className="queryCardBody">
            <div className="catInputRow">
              <div className="catInputWrap">
                <label className="catLabel">
                  Query Name <span className="required">*</span>
                </label>
                <input
                  className="catTextBox"
                  placeholder="Enter Type of Query"
                  value={typeInput}
                  onChange={(e) => setTypeInput(e.target.value)}
                  onKeyDown={(e) => e.key === "Enter" && handleAddType()}
                />
              </div>
              <button className="catAddBtn" onClick={handleAddType}>
                Add Type
              </button>
            </div>

            {/* ── Status list table ── */}
            <div className="catListWrap" style={{ height: "calc(100vh - 455px)" }}>
              <div className="catListHeader">
                <span>Type of Query</span>
              </div>

              {typeList.length === 0 && !loading && (
                <div className="catEmptyMsg">No Query Type found.</div>
              )}

              {typeList.map((item) => (
                <div className="catListRow" key={item.transid}>
                  {editingId === item.transid ? (
                    <div className="catEditRow">
                      <input
                        className="catTextBox"
                        value={editingValue}
                        onChange={(e) => setEditingValue(e.target.value)}
                        onKeyDown={(e) => {
                          if (e.key === "Enter") handleEditSave(item.transid);
                          if (e.key === "Escape") handleEditCancel();
                        }}
                        autoFocus
                      />
                      <button
                        className="catSaveBtn"
                        onClick={() => handleEditSave(item.transid)}
                      >
                        ✓
                      </button>
                      <button
                        className="catCancelBtn"
                        onClick={handleEditCancel}
                      >
                        ✕
                      </button>
                    </div>
                  ) : (
                    <>
                      <span className="catRowText">{item.tickettypename}</span>
                      <div className="catRowActions">
                        <button
                          className="catIconBtn editIcon"
                          title="Edit"
                          onClick={() => handleEditClick(item)}
                        >
                          <i className="ri-pencil-line" />
                        </button>
                        <button
                          className="catIconBtn deleteIcon"
                          title="Delete"
                          onClick={() => handleDelete(item.transid)}
                        >
                          <i className="ri-delete-bin-line" />
                        </button>
                      </div>
                    </>
                  )}
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
